<template>
  <div class="scrollbar h-full flex flex-col bg-lightgray-400">
    <div class="text-lg">
      <MenuSection
        v-for="(section, idx) in sections"
        :key="idx"
        :active-url
        :counts
        :is-server-admin
        :section />
    </div>
    <div class="grow" />
    <div class="flex justify-between border-t border-gray-400 px-4 pb-12 pt-4 text-2xl">
      <button class="my-auto block size-6" type="button" @click="logout">
        <iconify-icon icon="fas:arrow-right-from-bracket" />
      </button>
      <a class="block" href="https://ol-events.zendesk.com/hc/de" rel="noopener" target="_blank">
        <i class="fas fa-question-circle" />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import menu from '@/configs/menu';
import MenuSection from './menuSection.vue';

type Props = {
  counts: Record<string, number>;
  isServerAdmin?: boolean;
};
const props = defineProps<Props>();

function checkPermission(permission?: 'server-admin') {
  if (!permission) return true;
  return props.isServerAdmin === true;
}

const sections = menu.filter(section => checkPermission(section.permission));

const items = sections.flatMap(section => section.items);

const activeUrl = ref('');

const activeUrlLevel = ref(3);

getActiveUrl();

function getActiveUrl() {
  const currentPath = location.pathname.split('?')[0].replace(/\d+/g, '{id}').replace(/\/$/, '');
  for (const item of items) {
    const itemPath = item.url.replace(new RegExp(`^${document.location.origin.replace('.', '\\.')}`), '');

    if (currentPath === itemPath) {
      setActiveUrl(item.url, 1);
      continue;
    }
    if (item.additionalUrlMatches?.includes(currentPath) || item.additionalUrlMatches?.some(match => currentPath.startsWith(match))) {
      setActiveUrl(item.url, 2);
      continue;
    }
    if (currentPath.startsWith(itemPath)) {
      setActiveUrl(item.url, 3);
    }
  }
}

function setActiveUrl(url: string, level: number) {
  if (!activeUrl.value || activeUrlLevel.value > level) {
    activeUrl.value = url;
    activeUrlLevel.value = level;
  }
}

async function logout() {
  try {
    await useAxios(route('logout'), {
      method: 'post',
    });
    location.reload();
  }
  catch (error) {
    console.log(error);
  }
}
</script>
